import React from "react";
import { Page } from "../components/layout";
import { Accent } from "../components/typography";

const IndexPage = () => (
  <Page>
    <title>LastTalon</title>
    <h1>
      LastTalon.dev
      <br />
      <Accent>— coming soon!</Accent>
    </h1>
    <p>This website is currently under construction.</p>
  </Page>
);

export default IndexPage;
